module.exports = __webpack_public_path__ + "static/media/asuka-lose.4951ca50.png";